import type { MotionStyle } from 'motion/react'

export const HEADER_REM_SIZE = 3
export const HEADER_EXPANDED_GAP_REM_SIZE = 1
export const HEADER_EXPANDED_TITLE_REM_SIZE = 4
export const HEADER_EXPANDED_PADDING_BOTTOM_REM_SIZE = 1.25

/**
 * Defining the layout-related styles in JS as it's required for motion
 * to work properly with the layout prop.
 *
 * The styles are defined as functions to allow for dynamic values based on props.
 *
 * The `satisfies MotionStyle` assertion is used to ensure that the styles conform to the
 * MotionStyle type expected by motion.
 */

/* ignoring coverage for styles since they are equivalent to CSS */
/* v8 ignore start */
export const ANIMATED_LAYOUT = {
  header: (isExpanded: boolean) =>
    ({
      position: 'relative',
      height: isExpanded
        ? `${HEADER_REM_SIZE + HEADER_EXPANDED_GAP_REM_SIZE + HEADER_EXPANDED_TITLE_REM_SIZE + HEADER_EXPANDED_PADDING_BOTTOM_REM_SIZE}rem`
        : `${HEADER_REM_SIZE}rem`,
    }) satisfies MotionStyle,
  headerLayout: (isExpanded: boolean) =>
    ({
      position: 'absolute',
      top: '0',
      left: '0',
      right: '0',

      display: 'grid',
      gridTemplateColumns: 'auto 1fr auto',
      gridTemplateRows: isExpanded
        ? `${HEADER_REM_SIZE}rem ${HEADER_EXPANDED_TITLE_REM_SIZE}rem`
        : `${HEADER_REM_SIZE}rem`,
      gap: `${HEADER_EXPANDED_GAP_REM_SIZE}rem`,
      padding: `0 ${HEADER_EXPANDED_GAP_REM_SIZE}rem`,
      paddingBottom: isExpanded ? `${HEADER_EXPANDED_PADDING_BOTTOM_REM_SIZE}rem` : '0',
    }) satisfies MotionStyle,
  title: (isExpanded: boolean) =>
    (isExpanded
      ? {
          gridRow: '2',
          gridColumn: '1 / -1',
          display: 'grid',
          gridTemplateRows: 'auto auto',
          gap: `${HEADER_EXPANDED_GAP_REM_SIZE}rem`,
        }
      : {
          display: 'grid',
          gridTemplateColumns: 'auto 1fr',
          gap: '0.5rem',
          alignItems: 'center',
        }) satisfies MotionStyle,
}
/* v8 ignore stop */
